import type { WorkOption } from '../types';

export const workOptions: Array<{ value: WorkOption; label: string }> = [
  { value: 'ux-discovery', label: 'Working on UX discovery for a specific problem' },
  { value: 'explore-problem', label: 'Explore UX problem and generate solution for it' },
  { value: 'generate-solutions', label: 'Quickly generate solutions for a known problem' },
  { value: 'not-sure', label: 'Not sure yet, start exploring' },
];

export const workOptionMockupMap: Record<WorkOption, string> = {
  'ux-discovery': 'https://files.ideoz.ai/uxDiscoveryMockup.jpg',
  'explore-problem': 'https://files.ideoz.ai/exploreProblemMockup.jpg',
  'generate-solutions': 'https://files.ideoz.ai/generalSolutionMockup.jpg',
  'not-sure': 'https://files.ideoz.ai/notSureMockup.jpg',
};

